module.exports = __webpack_public_path__ + "img/health-guide-download.585c796c.svg";